import {StrictMode} from "react";
import ReactDOM from "react-dom";

import ResponsiveApp from "./ResponsiveApp";
import {initSolarEngine, trackSolarEvent} from "./utils/solarEngine";

const MOBILE_BREAKPOINT = 1366;
const appMode = window.innerWidth < MOBILE_BREAKPOINT ? "h5" : "pc";

const actionEventMap = {
    enter: "app_start",
    reservation: "reservation_success"
};
const action = new URLSearchParams(window.location.search).get("action");
const actionEventName = actionEventMap[action];

initSolarEngine({appMode});

ReactDOM.render(
    <StrictMode>
        <ResponsiveApp/>
    </StrictMode>,
    document.getElementById("root")
);

if (actionEventName) {
    trackSolarEvent(actionEventName, {app_mode: appMode});
}
